module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fs",
    attrs: {
      "id": "page018"
    }
  }, [_c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_1"
    }
  }, [_vm._v("APRICOT CROISSANTS")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_2"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("roissants à l")]), _vm._v("’A"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("bricot")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_3"
    }
  }, [_vm._v("TIME REQUIRED:")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_4"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("roissants are said")]), _vm._v(" to be named after the crescent moon, which")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_5"
    }
  }, [_vm._v("25 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_6"
    }
  }, [_vm._v("they resemble. Although they’re time-consuming to make, you’ll")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_7"
    }
  }, [_vm._v("be rewarded by their incomparably soft and flaky texture.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_8"
    }
  }, [_vm._v("+ about 12 hours cooling")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_9"
    }
  }, [_vm._v("and resting time")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_10"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_10a"
    }
  }, [_c('span', {
    staticClass: "page018_10a"
  }, [_vm._v(" Combine the milk and water in a bowl. Mix the flour, salt,")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_11"
    }
  }, [_vm._v("sugar and yeast separately and add to the mixture. Finally, add")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_12"
    }
  }, [_vm._v("Makes 8")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_13"
    }
  }, [_vm._v("the melted margarine. Knead briefly with a mixer fitted with")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_14"
    }
  }, [_vm._v("500 g vegan leavened")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_15"
    }
  }, [_vm._v("a dough hook on low speed for about 1 minute (add a little")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_16"
    }
  }, [_vm._v("laminated (croissant or")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_17"
    }
  }, [_vm._v("water or flour if necessary). Roll the dough into a ball, transfer")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_18"
    }
  }, [_vm._v("Danish pastry) dough")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_19"
    }
  }, [_vm._v("to a bowl greased with oil and rest for at least 6 hours in the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_20"
    }
  }, [_vm._v("8 tbsp apricot jam")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_21"
    }
  }, [_vm._v("refrigerator.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_22"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_22a"
    }
  }, [_c('span', {
    staticClass: "page018_22a"
  }, [_vm._v("Next, cut the cold margarine into small pieces and knead")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_23"
    }
  }, [_vm._v("Vegan cream, for glazing")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_24"
    }
  }, [_vm._v("with a teaspoon of flour. Work quickly to prevent the margarine")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_25"
    }
  }, [_vm._v("becoming too soft. Put the margarine on a sheet of aluminium")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_26"
    }
  }, [_vm._v("For the dough:")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_27"
    }
  }, [_vm._v("foil and shape into a 15-cm square about 5 mm in thickness.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_28"
    }
  }, [_vm._v("225 g flour")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_29"
    }
  }, [_vm._v("Wrap it in foil and rest in the refrigerator for 1 hour.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_30"
    }
  }, [_vm._v("1 pinch salt")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_31"
    }
  }, [_vm._v("3.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_31a"
    }
  }, [_c('span', {
    staticClass: "page018_31a"
  }, [_vm._v("Roll out the dough on a floured work surface into roughly 30 x")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_32"
    }
  }, [_vm._v("20 g sugar")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_33"
    }
  }, [_vm._v("20-cm rectangle. Lay the margarine square on the left side of the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_34"
    }
  }, [_vm._v("½ sachet dry yeast")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_35"
    }
  }, [_vm._v("dough and fold the right side over to encase it. Seal the edges well.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_36"
    }
  }, [_vm._v("75 ml soya milk")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_37"
    }
  }, [_vm._v("Use a rolling pin to carefully roll out the dough into a 40 x 20-cm")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_38"
    }
  }, [_vm._v("80 ml cold water")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_39"
    }
  }, [_vm._v("sheet. Fold the right and left edges over into the middle and rest")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_40"
    }
  }, [_vm._v("10 g high-quality vegan")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_41"
    }
  }, [_vm._v("in the refrigerator for about 30 minutes.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_42"
    }
  }, [_vm._v("margarine, melted")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_43"
    }
  }, [_vm._v("4.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_43a"
    }
  }, [_c('span', {
    staticClass: "page018_43a"
  }, [_vm._v("Place the dough on a floured work surface. Carefully roll it out")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_44"
    }
  }, [_vm._v("again to a 40 x 20-cm sheet then fold it into thirds. Rest in the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_45"
    }
  }, [_vm._v("125 g high-quality vegan")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_46"
    }
  }, [_vm._v("refrigerator for 30 minutes and then repeat the operation. Then")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_47"
    }
  }, [_vm._v("margarine, cold")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_48"
    }
  }, [_vm._v("refrigerate the dough for 20 more minutes.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_49"
    }
  }, [_vm._v("1 tsp plain flour")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_50"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "pagen"
  }, [_vm._v("asics")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page018_0"
    }
  }, [_vm._v("18")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ed35619","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_018.vue
// module id = 108
// module chunks = 0